module.exports = __webpack_public_path__ + "img/8.05c4e9d2.jpg";